import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'
import downLoader from './modules/downLoader.modules'
import common from './modules/common.modules'
import packages from './modules/package.modules'
import device from './modules/device.modules'
import { modulesName } from '../lib/const'

Vue.use(Vuex)
const store = new Vuex.Store({
  state: {
    showLoading: false,
    loadingMsg: 'Loading...',
    loadingMsg_local: 'Loading...',
    showLoading_local: false,
    activeTabItem: 'home'
  },
  mutations: {
    setActiveTabbarItem (state, item = 'home') {
      state.activeTabItem = item
    },
  },
  actions: {},
  modules: {
    [modulesName.auth]: auth,
    [modulesName.downLoader]: downLoader,
    [modulesName.common]: common,
    [modulesName.package]: packages,
    [modulesName.device]: device
  }
})
export default store
